export function linkCard() {
var cards = document.querySelectorAll(".clickablecard");
for (var i=0; i<cards.length; i++) {
  cards[i].addEventListener('click', function(e) {

    if (e.target.tagName === 'A' && e.target.classList.contains('cardmainlink')) {
      return;
    }

    var link = this.querySelector(".cardmainlink");
    link.click();
  }, false);
}

};
